module.exports = __webpack_public_path__ + "media/images/heathered-07bf02ea.gif";